import {
  getEmailDomain,
  getWebsiteDomain,
  isDomainMatching,
  isEmailDomainInList,
} from '../contacts/emailValidation'

export interface IValidationRule {
  CountryCode: string
  Fmt: string
  IsRequired: number
  Type: string
}

interface IsValidEmailDomainProps {
  value: string
  companyUrl: string
  validationRules: IValidationRule[]
  emailList: string[]
}

export const checkEmailDomain = async ({
  value,
  companyUrl,
  validationRules,
  emailList,
}: IsValidEmailDomainProps) => {
  let tooltipText: string = ''

  const isDomainMatchRequired = Boolean(
    validationRules.find(
      (e) => e.Type.toUpperCase() === 'DOMAINMATCHREQUIREMENT' && e.IsRequired === 1
    )
  )
  const isDomainValid =
    !companyUrl || isDomainMatching(value, companyUrl) || isEmailDomainInList(value, emailList)

  if (isDomainMatchRequired && !isDomainValid) {
    const urlDomain = getWebsiteDomain(companyUrl)

    const uniqueDomains = [...new Set(emailList.map((email) => getEmailDomain(email)))]
    if (urlDomain && !uniqueDomains.includes(urlDomain)) {
      uniqueDomains.push(urlDomain)
    }
    tooltipText = `Incorrect Email. Please use a business email address that matches your company's domain ([${uniqueDomains.join(', ')}])`
  }

  return tooltipText
}
